import { PortfolioService } from '../services/portfolioService';
import { PositionService } from '../services/positionService';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import { Portfolio } from '../types';

export async function fixAvailableFunds() {
  console.log('Fixing totalEarnings and availableFunds for ALL portfolios (all users)...');

  try {
    // Query ALL portfolios directly - bypasses user filter in PortfolioService
    const querySnapshot = await getDocs(collection(db, 'portfolios'));
    const portfolios: Portfolio[] = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      portfolios.push({
        ...data,
        id: doc.id,
        totalEarnings: data.totalEarnings || 0,
        availableFunds: data.availableFunds || 0,
        initialFundValue: data.initialFundValue || 0,
      } as Portfolio);
    });

    console.log(`Found ${portfolios.length} portfolios across all users`);
    let fixedCount = 0;

    for (const portfolio of portfolios) {
      // Get all closed positions - source of truth for totalEarnings
      const closedPositions = await PositionService.getClosedPositions(portfolio.id);
      const correctTotalEarnings = closedPositions.reduce(
        (sum, position) => sum + (position.realizedGainLoss || 0),
        0
      );

      // Get all open positions for available funds calculation
      const openPositions = await PositionService.getOpenPositions(portfolio.id);
      const openPositionsCost = openPositions.reduce(
        (sum, position) => sum + (position.entryPrice * position.quantity),
        0
      );

      // Calculate available funds: initial fund - open positions cost + realized losses
      const realizedLosses = Math.min(0, correctTotalEarnings);
      const correctAvailableFunds = portfolio.initialFundValue - openPositionsCost + realizedLosses;

      const earningsDiff = Math.abs(correctTotalEarnings - (portfolio.totalEarnings || 0));
      const fundsDiff = Math.abs(correctAvailableFunds - (portfolio.availableFunds || 0));
      const hasDiscrepancy = earningsDiff > 0.01 || fundsDiff > 0.01;

      if (hasDiscrepancy) {
        fixedCount++;
        console.log(`FIXING ${portfolio.name} (${portfolio.type || 'unknown'}, user: ${portfolio.userId}):`);
        if (earningsDiff > 0.01) {
          console.log(`  totalEarnings: $${(portfolio.totalEarnings || 0).toFixed(2)} → $${correctTotalEarnings.toFixed(2)} (diff: $${earningsDiff.toFixed(2)})`);
        }
        if (fundsDiff > 0.01) {
          console.log(`  availableFunds: $${(portfolio.availableFunds || 0).toFixed(2)} → $${correctAvailableFunds.toFixed(2)} (diff: $${fundsDiff.toFixed(2)})`);
        }
        console.log(`  Closed positions: ${closedPositions.length}, Open positions: ${openPositions.length}`);
      } else {
        console.log(`OK ${portfolio.name}: totalEarnings=$${correctTotalEarnings.toFixed(2)}, availableFunds=$${correctAvailableFunds.toFixed(2)}`);
      }

      // Update both totalEarnings and availableFunds
      await PortfolioService.updatePortfolioAfterClose(
        portfolio.id,
        correctAvailableFunds,
        correctTotalEarnings
      );
    }

    console.log(`\nFix completed! ${fixedCount} portfolios had discrepancies out of ${portfolios.length} total.`);
  } catch (error) {
    console.error('Error fixing portfolio totals:', error);
  }
}
